/* Small, dependency-free enhancements. All content remains usable without JavaScript. */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-pb-quantity]').forEach((input) => {
    input.addEventListener('change', () => { if (Number(input.value) < 1) input.value = 1; });
  });
  document.querySelectorAll('[data-pb-scroll]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) { event.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-pb-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('.pb-product-page__main-image img');
    gallery.querySelectorAll('[data-pb-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!main) return;
        main.src = thumb.dataset.pbImage;
        main.alt = thumb.dataset.pbAlt || main.alt;
        gallery.querySelectorAll('[data-pb-gallery-thumb]').forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });
  document.querySelectorAll('[data-pb-product]').forEach((product) => {
    const select = product.querySelector('[data-pb-variant-select]');
    const price = product.querySelector('[data-pb-price]');
    const currentPrice = product.querySelector('[data-pb-current-price]');
    const comparePrice = product.querySelector('[data-pb-compare-price]');
    const salePill = product.querySelector('[data-pb-sale-pill]');
    const salePercent = product.querySelector('[data-pb-sale-percent]');

    if (select && price) select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const priceValue = option.dataset.pbPriceValue || '';

      if (!currentPrice) {
        price.textContent = priceValue || price.textContent;
        return;
      }

      currentPrice.textContent = priceValue || currentPrice.textContent;
      const priceCents = Number(option.dataset.pbPriceCents || 0);
      const compareAtCents = Number(option.dataset.pbCompareAtPriceCents || 0);
      const hasSale = compareAtCents > priceCents && priceCents > 0;

      if (comparePrice) {
        comparePrice.textContent = option.dataset.pbCompareAtPriceValue || '';
        comparePrice.hidden = !hasSale;
      }
      if (salePill) salePill.hidden = !hasSale;
      if (salePercent && hasSale) salePercent.textContent = String(Math.round(((compareAtCents - priceCents) / compareAtCents) * 100));
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-pb-delivery]').forEach((delivery) => {
    const days = Number(delivery.dataset.days || 0);
    const target = delivery.querySelector('[data-pb-delivery-date]');
    if (!target || !days) return;
    const date = new Date();
    date.setDate(date.getDate() + days);
    const label = date.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' });
    target.textContent = `${target.textContent} ${label}`;
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const cartCounts = document.querySelectorAll('[data-pb-cart-count]');
  if (!cartCounts.length) return;

  const refreshCartCount = async () => {
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      cartCounts.forEach((count) => { count.textContent = String(cart.item_count || 0); });
      document.querySelectorAll('[data-pb-cart-link]').forEach((link) => {
        link.setAttribute('aria-label', `Open shopping bag, ${cart.item_count || 0} items`);
      });
    } catch (error) {
      // The server-rendered Liquid count remains visible if a cart app blocks this request.
    }
  };

  refreshCartCount();
  window.addEventListener('focus', refreshCartCount);
  document.addEventListener('cart:updated', refreshCartCount);
});
/* PUREBOWL PRODUCT PAGE UPDATE — ADD TO BOTTOM ONLY */
(() => {
  const onReady = (callback) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback);
    else callback();
  };

  onReady(() => {
    /* Product gallery: Previous / Next, thumbnail click, keyboard and swipe. */
    document.querySelectorAll('[data-pb-gallery]').forEach((gallery) => {
      if (gallery.dataset.pbGalleryEnhanced === 'true') return;

      const mainFrame = gallery.querySelector('.pb-product-page__main-image');
      const mainImage = mainFrame?.querySelector('img');
      const thumbs = Array.from(gallery.querySelectorAll('[data-pb-gallery-thumb]'));
      if (!mainFrame || !mainImage || thumbs.length < 2) return;

      gallery.dataset.pbGalleryEnhanced = 'true';
      mainFrame.setAttribute('tabindex', '0');
      mainFrame.setAttribute('aria-label', `${mainImage.alt || 'Product'} images. Use Previous and Next to browse.`);

      let previous = gallery.querySelector('[data-pb-gallery-prev]');
      let next = gallery.querySelector('[data-pb-gallery-next]');
      let touchStartX = null;

      const createControl = (direction, label) => {
        const button = document.createElement('button');
        button.className = `pb-product-page__gallery-control pb-product-page__gallery-control--${direction}`;
        button.type = 'button';
        button.setAttribute(`data-pb-gallery-${direction === 'previous' ? 'prev' : 'next'}`, '');
        button.setAttribute('aria-label', `View ${label.toLowerCase()} product image`);
        button.innerHTML = `<span>${label}</span>`;
        mainFrame.appendChild(button);
        return button;
      };

      if (!previous) previous = createControl('previous', 'Previous');
      if (!next) next = createControl('next', 'Next');

      const activeIndex = () => Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));

      const showImage = (index, scrollThumb = true) => {
        const nextIndex = (index + thumbs.length) % thumbs.length;
        const thumb = thumbs[nextIndex];

        mainImage.src = thumb.dataset.pbImage;
        mainImage.alt = thumb.dataset.pbAlt || mainImage.alt;

        thumbs.forEach((item, itemIndex) => {
          const active = itemIndex === nextIndex;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-current', active ? 'true' : 'false');
        });

        if (scrollThumb) {
          thumb.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }
      };

      const moveImage = (direction) => showImage(activeIndex() + direction);

      thumbs.forEach((thumb, index) => {
        thumb.setAttribute('aria-current', thumb.classList.contains('is-active') ? 'true' : 'false');
        thumb.addEventListener('click', () => showImage(index, false));
      });

      previous.addEventListener('click', () => moveImage(-1));
      next.addEventListener('click', () => moveImage(1));

      mainFrame.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          moveImage(-1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          moveImage(1);
        }
      });

      mainFrame.addEventListener('pointerdown', (event) => {
        touchStartX = event.clientX;
      });

      mainFrame.addEventListener('pointerup', (event) => {
        if (touchStartX === null || Math.abs(event.clientX - touchStartX) < 36) return;

        moveImage(event.clientX < touchStartX ? 1 : -1);
        touchStartX = null;
      });

      mainFrame.addEventListener('pointercancel', () => {
        touchStartX = null;
      });
    });

    /* Main price mirrors the active Appstle purchase option on regular meals. */
    document.querySelectorAll('[data-pb-product]').forEach((product) => {
      if (product.dataset.pbAppstlePriceEnhanced === 'true') return;

      const productSection = product.closest('.pb-product-page');
      const isStarterBox = /^\/products\/purebowl-starter-box\/?$/.test(window.location.pathname);

      /* Keeps your Starter Box crossed-out sale price untouched. */
      if (isStarterBox) return;

      const price = product.querySelector('[data-pb-price]');
      const appBlocks = product.querySelector('.pb-product-page__app-blocks');

      if (!price || !appBlocks) return;

      product.dataset.pbAppstlePriceEnhanced = 'true';
      price.classList.add('pb-product-page__price--appstle-sync');

      let currentPrice = product.querySelector('[data-pb-current-price]');
      let comparePrice = product.querySelector('[data-pb-compare-price]');
      let salePill = product.querySelector('[data-pb-sale-pill]');
      let salePercent = product.querySelector('[data-pb-sale-percent]');
      let selectedPriceLabel = product.querySelector('[data-pb-selected-price-label]');
      let mobilePrice = productSection?.querySelector('[data-pb-mobile-price]');

      if (!currentPrice) {
        const existingPrice = price.textContent.trim();

        price.innerHTML = `
          <s data-pb-compare-price hidden></s>
          <span data-pb-current-price>${existingPrice}</span>
          <span class="pb-product-page__sale-pill" data-pb-sale-pill hidden>
            Save&nbsp;<span data-pb-sale-percent></span>%
          </span>
        `;

        currentPrice = price.querySelector('[data-pb-current-price]');
        comparePrice = price.querySelector('[data-pb-compare-price]');
        salePill = price.querySelector('[data-pb-sale-pill]');
        salePercent = price.querySelector('[data-pb-sale-percent]');
      }

      if (!selectedPriceLabel) {
        selectedPriceLabel = document.createElement('p');
        selectedPriceLabel.className = 'pb-product-page__selected-price-label';
        selectedPriceLabel.setAttribute('data-pb-selected-price-label', '');
        selectedPriceLabel.hidden = true;
        price.insertAdjacentElement('afterend', selectedPriceLabel);
      }

      if (!mobilePrice) {
        mobilePrice = productSection?.querySelector('.pb-product-page__mobile-buy > div > span');
        mobilePrice?.setAttribute('data-pb-mobile-price', '');
      }

      const text = (element) => (element?.textContent || '').replace(/\s+/g, ' ').trim();

      const visibleText = (scope, selector) => {
        const match = Array.from(scope?.querySelectorAll(selector) || []).find(
          (element) => !element.classList.contains('sr-only') && text(element)
        );

        return text(match);
      };

      const samePrice = (first, second) => {
        return first.replace(/[^0-9.]/g, '') === second.replace(/[^0-9.]/g, '');
      };

      let regularPrice = text(currentPrice);
      let regularComparePrice = text(comparePrice);
      let regularCompareHidden = !comparePrice || comparePrice.hidden;
      let regularSaleHidden = !salePill || salePill.hidden;
      let regularSalePercent = text(salePercent);
      let regularMobilePrice = text(mobilePrice);
      let showingSubscriptionPrice = false;
      let scheduled = false;

      const rememberRegularPrice = () => {
        if (showingSubscriptionPrice) return;

        regularPrice = text(currentPrice);
        regularComparePrice = text(comparePrice);
        regularCompareHidden = !comparePrice || comparePrice.hidden;
        regularSaleHidden = !salePill || salePill.hidden;
        regularSalePercent = text(salePercent);
        regularMobilePrice = text(mobilePrice);
      };

      const showRegularPrice = () => {
        currentPrice.textContent = regularPrice;

        if (mobilePrice) {
          mobilePrice.textContent = regularMobilePrice || regularPrice;
        }

        if (comparePrice) {
          comparePrice.textContent = regularComparePrice;
          comparePrice.hidden = regularCompareHidden;
        }

        if (salePill) salePill.hidden = regularSaleHidden;

        if (salePercent && regularSalePercent) {
          salePercent.textContent = regularSalePercent;
        }

        selectedPriceLabel.textContent = '';
        selectedPriceLabel.hidden = true;
        showingSubscriptionPrice = false;
      };

      const syncAppstlePrice = () => {
        const widget = appBlocks.querySelector(
          '.appstle_sub_widget, [id^="appstle_subscription_widget"]'
        );

        const selectedPlan = widget?.querySelector(
          'input[name="selling_plan"]:checked, input[name*="selling_plan"]:checked'
        );

        if (!widget || !selectedPlan || !selectedPlan.value) {
          if (showingSubscriptionPrice) showRegularPrice();
          return;
        }

        const selectedOption = selectedPlan.closest('.appstle_subscription_wrapper_option');
        const subscriptionPrice = visibleText(selectedOption, '.appstle_subscription_amount');
        const subscriptionComparePrice = visibleText(
          selectedOption,
          '.appstle_subscription_compare_amount'
        );

        const deliveryFrequency = widget.querySelector('.appstle_select');
        const frequencyLabel =
          deliveryFrequency?.options[deliveryFrequency.selectedIndex]?.text?.trim() ||
          'Subscription';

        if (!subscriptionPrice) return;

        currentPrice.textContent = subscriptionPrice;

        if (mobilePrice) {
          mobilePrice.textContent = subscriptionPrice;
        }

        const hasSaving =
          subscriptionComparePrice &&
          !samePrice(subscriptionPrice, subscriptionComparePrice);

        if (comparePrice) {
          comparePrice.textContent = subscriptionComparePrice || '';
          comparePrice.hidden = !hasSaving;
        }

        if (salePill) salePill.hidden = true;

        selectedPriceLabel.textContent = `${frequencyLabel} subscription price`;
        selectedPriceLabel.hidden = false;
        showingSubscriptionPrice = true;
      };

      const queuePriceSync = () => {
        if (scheduled) return;

        scheduled = true;

        window.requestAnimationFrame(() => {
          scheduled = false;
          syncAppstlePrice();
        });
      };

      appBlocks.addEventListener('change', () => {
        window.setTimeout(queuePriceSync, 0);
      });

      appBlocks.addEventListener('click', (event) => {
        if (
          event.target.closest(
            '.appstle_radio_label, .appstle_subscription_wrapper_option, .appstle_select'
          )
        ) {
          window.setTimeout(queuePriceSync, 0);
        }
      });

      new MutationObserver(queuePriceSync).observe(appBlocks, {
        attributes: true,
        attributeFilter: ['class', 'checked', 'value'],
        childList: true,
        subtree: true
      });

      queuePriceSync();
    });

    /* Starter Box reels: autoplay, loop, always muted and no controls. */
    if (/^\/products\/purebowl-starter-box\/?$/.test(window.location.pathname)) {
      document
        .querySelectorAll('.pb-product-inline-reels video, .pb-product-reels video')
        .forEach((video) => {
          const keepPlaying = () => {
            video.muted = true;
            video.defaultMuted = true;
            video.autoplay = true;
            video.loop = true;
            video.controls = false;
            video.removeAttribute('controls');
            video.setAttribute('muted', '');
            video.setAttribute('playsinline', '');

            const playAttempt = video.play();
            if (playAttempt) playAttempt.catch(() => {});
          };

          keepPlaying();
          video.addEventListener('canplay', keepPlaying, { once: true });
          video.addEventListener('ended', keepPlaying);

          document.addEventListener('visibilitychange', () => {
            if (!document.hidden) keepPlaying();
          });
        });
    }
  });
})();
